import { ClientDashboardHomeDetailsDto } from '@hoqus/connectis-client-dashboard-types';
import { mapDtoToDashboardHomeJobOrder } from 'types/DashboardHomeJobOrder/mapper.ts';
import { mapDtoToDashboardNotificationType } from '../DashboardNotification/mapper.ts';
import { mapDtoToSalesType } from '../Sales/mapper.ts';
import { DashboardHomeDetailsType } from './DashboardHomeDetailsType.ts';

export const mapDtoToDashboardHomeDetailsType = (
  dto: ClientDashboardHomeDetailsDto,
): DashboardHomeDetailsType => ({
  id: dto.id,
  createdAt: dto.createdAt,
  clientName: dto.companyContactName,
  notifications: dto.notifications.map(mapDtoToDashboardNotificationType) || [],
  sales: mapDtoToSalesType(dto.sales),
  jobOrders: dto.jobOrders.map(mapDtoToDashboardHomeJobOrder) || [],
});
